import { Directive, Input, TemplateRef, ViewContainerRef, ComponentRef } from '@angular/core';
import { LoadingComponent } from './loading.component';
import { __ } from '../../functions/object.functions';

@Directive({
    selector: '[loading]',
    standalone: false
})
export class LoadingDirective {

    private wrapperContainer: ComponentRef<LoadingComponent>;

    private isLoading: boolean = false;

    private cssClass: string = '';

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainerRef: ViewContainerRef
    ) { }

    @Input() set loading(isLoading: boolean) {
        this.isLoading = isLoading;
        this.renderLoading();
    }

    @Input() set loadingClass(loadingClass: string) {
        this.cssClass = loadingClass;
        this.renderLoading();
    }

    private renderLoading() {
        if (__.IsNullOrUndefined(this.isLoading) && __.IsNullOrUndefined(this.loadingClass)) {
            return;
        }

        if (__.IsNullOrUndefined(this.wrapperContainer)) {
            this.wrapperContainer = this.viewContainerRef.createComponent(LoadingComponent);
        }

        this.wrapperContainer.instance.templateRef = this.templateRef;
        this.wrapperContainer.instance.isLoading = this.isLoading;
        this.wrapperContainer.instance.cssClass = this.cssClass;
    }
}
